// extracted by mini-css-extract-plugin
module.exports = {"inputLabel":"Label_inputLabel__3dQk4"};